import React, { Component } from "react";
import ReactDOM from "react-dom";
import uv4lClient from "../../../uv4l.js";
// import UAParser from "ua-parser-js";

class IntercomPad extends Component {
  constructor() {
    super();
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.reset = this.reset.bind(this);
    this.mute = this.mute.bind(this);
    this.unMute = this.unMute.bind(this);
    this.stateHandler = this.stateHandler.bind(this);
    this.getVideoId = this.getVideoId.bind(this);
    this.state = {
      value: "FIN-OFF",
      line_busy: false,
    }
  
  }

  componentWillUnmount() {
    this.stop();
  }
  start() {
    const location_protocol = "https:";
    // const intercom_id = "pi3";
    const remote_video_element_id = this.getVideoId()
    
    this.uv4l_client = uv4lClient(this.props.intercom_id, remote_video_element_id, this.stateHandler);    
    this.uv4l_client.start();
    if (this.shut_down_timer){
      clearTimeout(this.shut_down_timer);
    }
    this.shut_down_timer = setTimeout(this.stop, 180000);
  }
  stop() {
    if (this.shut_down_timer){
      clearTimeout(this.shut_down_timer);
    }
    if (this.uv4l_client){
      this.uv4l_client.stop();
    }
  }
  reset() {
    let el = document.getElementById(this.getVideoId());
    let src = el.srcObject;
    el.srcObject = null;
    el.srcObject = src;
  }

  mute() {
      this.uv4l_client.mute_mic();
  }
  unMute() {
        this.uv4l_client.unmute_mic();
  }
  stateHandler(state) {
    console.log("setting intercom state", state)
    if (state.state == "FIN-ON_TRACK"){
      //needed for safari to default to loud speaker: 
      //https://bugs.webkit.org/show_bug.cgi?id=196539
      console.log("schedule a reset");
      setTimeout(this.reset, 2000);

    }
    this.setState({value: state.state})
  }
  getVideoId() {
    return "icomm-video-" + this.uid + this.props.camId;
  }

  render(){

      let controls = undefined;
      let busymessage = undefined;

      if (this.state.value.startsWith("FIN-OFF") ){
        //call is OFF
        controls = <button className="button-container intercom-button fa fa-phone button-action-bgcolor" onClick={this.start}></button>;
        if (this.state.value.endsWith("BUSY") ){
          this.setState({"line_busy" : true})
          this.stateHandler({state: "FIN-OFF"});
          // setTimeout(clear_line_busy)
        }
        
        if (this.state.line_busy){
          busymessage = <div className="intercom-busy">Line is in use</div>
        }
      }
      else if (this.state.value.startsWith("FIN-ON") ){
        let mic_button = undefined;
        if (this.state.value.endsWith("MICMUTED")){
          mic_button = (
            <button 
              className="button-container intercom-button fa fa-microphone-slash " 
              onClick={this.unMute}
            />
          );

        }
        else{
          mic_button = (
            <button 
              className="button-container intercom-button fa fa-microphone button-secondary-bgcolor" 
              onClick={this.mute}
            />
          );

        }
        //call is ON
        controls = (
          <div className="intercom-active">
            {/* <div className="intercom-button fa fa-volume-up intercom-speaker-color" ></div> */}
            {mic_button}
            <button 
              className="button-container intercom-button fa fa-phone button-red-bgcolor" 
              onClick={this.stop} 
              />
          </div>
        );
      }
      else{
        controls = <button className="button-container intercom-button fa fa-phone button-disabled button-action-bgcolor" disabled ></button>
        
        //intermediate state
      }
      let intercom = (
        <div className="intercom-sub-container">
          {controls}
          {busymessage}
          <video className="intercom-video" id={this.getVideoId()} autoPlay playsInline ></video>
        </div>
      )
  
      return (intercom);
    }

  }

export default IntercomPad;